import styled, { css } from 'styled-components';
import { StatusOptions } from '@models/Onboarding.model';
import COLORS from '@styles/colors/themes/beam/beam2';

export const RequestStatusWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 9px;
`;

export const CircularFileImportProgressWrapper = styled.div`
  position: relative;
  height: 14px;
  width: 14px;
  border-radius: 100%;
  background-color: transparent;

  & .overllProgress {
    position: absolute;
    top: 0;
    color: #d6e0ff;
  }

  & .completedProgress {
    position: absolute;
    top: 0;
    color: ${COLORS.blue.b401};

    circle:nth-child(1) {
      stroke-linecap: round;
    }
  }
`;

export const RequestStatusBadge = styled.span`
  padding: 3px;
  border-radius: 100%;

  ${(props: { $status: StatusOptions }) => {
    if (props.$status === 'open') {
      return css`
        background: ${COLORS.blue.b401};
      `;
    }
    if (['closed', 'aborted', 'deleted'].includes(props.$status)) {
      return css`
        background: ${COLORS.red.r400};
      `;
    }
    return css`
      background: #c2caf8;
    `;
  }}
`;

export const RequestStatusTag = styled.p`
  font-family: 'Poppins' sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  margin: unset;
  color: #7380c0;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;

  ${(props: { $status?: StatusOptions }) =>
    props.$status === 'open' &&
    css`
      color: ${COLORS.blue.b401};
    `}
`;
